// src/components/intake/useQuote.js
//
// The live estimate for a set of book specs, from the same endpoint the /quote
// page uses, so the two pages can never disagree on a price. Debounced: a
// number field fires on every keystroke.

import { useEffect, useState } from 'react';
import { intakeApi } from './api';

export default function useQuote(specs) {
  const [quote, setQuote] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!specs) return undefined;
    let cancelled = false;
    const timer = setTimeout(async () => {
      try {
        const next = await intakeApi.quote(specs);
        if (!cancelled) {
          setQuote(next);
          setError(null);
        }
      } catch {
        if (!cancelled) setError("We couldn't work out the price just now.");
      }
    }, 250);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [specs]);

  return { quote, error };
}
